
<template>
  <v-layout row justify-center>
 
      <!-- <v-btn slot="activator" color="primary" dark>Open Dialog</v-btn> -->
      <v-card>
        <v-card-title>
          <span class="headline">Transfer tokens</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <!-- <v-autocomplete
                  v-model="txParams.symbol"
                  label="Token/Item"
                  :items="['AAA']"
                  hint="The symbol (ie 'NFT')"
                ></v-autocomplete> -->
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field v-model="txParams.amount" label="Amount" hint="How much do you want to transfer?"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-autocomplete
                  v-model="txParams.sender"
                  :items="accountList"
                  label="Sender"
                  
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-autocomplete
                  v-model="txParams.receiver"
                  :items="accountList"
                  label="Receiver"
                  
                ></v-autocomplete>
              </v-flex>
              
            </v-layout>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="closeDialog()">Close</v-btn>
          <v-btn color="blue darken-1" flat @click="transfer()">Tansfer</v-btn>
        </v-card-actions>
      </v-card>
 
      <DialogLoader :dialog="!transactionReq.success" :message="transactionReq.message"></DialogLoader>
  </v-layout>

</template>

<script>
  import { mapState } from 'vuex'
  import store from "@/store"

  import DialogLoader from "@/components/loading/dialogLoader.vue"

  export default {
    props: {
      dialogg: Boolean
    },
    components: {
      DialogLoader
    },
    computed: {
      ...mapState({
          myAccounts: state => state.contractsDb.myAccounts,
          myContracts: state => state.contractsDb.myContracts,
      }),
      accountList: function  () {
        let accounts = this.myAccounts.Items
        accounts = accounts.concat(this.myContracts.Items)
        let accountList = []
        for (var i = 0; i < accounts.length; i++) {
          console.log(accounts[i])
          accountList.push(accounts[i].account_name.S)
        }

        return accountList
      }

    },
    watch: {
      dialogg () {
        this.dialog = this.dialogg
      }
    },
    methods: {
      closeDialog(event) {
        this.$emit('closeDialog', event)
      },
      transfer() {
        let self = this
        console.log(self.txParams)

        store.commit('contractsDb/txSentTrigger')

        this.txParams.contract = this.myContracts.Items[0].account_name.S
        async function transfer () {
          self.transactionReq = {success: false}
          await self.$store.dispatch('contractsDb/transferToken', self.txParams).then(function  () {

            setTimeout(function () {
              self.transactionReq = {success: false, message: " - Complete."}
            }, 800)

            setTimeout(function () {
              self.transactionReq = {success: true}

              self.closeDialog() 
            }, 1800)
            
          })


          // let self = this
          // In a couple secs fetch the latest balances of the main accounts
          // TODO this is hacky and heavy as users get more accounts - find beter solution
          setTimeout(function () {
            self.$store.dispatch('contractsDb/getCurrencyBalances', {
              account:self.myContracts.Items[0].account_name.S,
              contract:self.myContracts.Items[0].account_name.S,
              symbol:'AAA'
            })
           
          }, 11000)
          setTimeout(function () {
            (self.myAccounts.Items).map((account) => {
              self.$store.dispatch('contractsDb/getCurrencyBalances', {
                account:account.account_name.S,
                contract:self.myContracts.Items[0].account_name.S,
                symbol:'AAA'
              })
            });
          }, 11000)

        
        } 
        transfer()
      }
    },
    data () {
      return {
        transactionReq: {success: true},
        dialog: true,
        false: false,
        txParams: {
          symbol:'AAA',
          amount:'',
          sender: '',
          receiver:'',
          contract: '',
          survey_hash: 'smartpress transfer'
        }
      }
    }
  }
</script>